<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
    :visible.sync="visible">
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="12">
            <el-form-item label="工程编号" prop="proCode"
                :rules="[
                 ]">
              <el-input v-model="inputForm.proCode" placeholder="请填写工程编号"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="是否配置完成" prop="isFinish"
                :rules="[
                 ]">
              <el-input v-model="inputForm.isFinish" placeholder="请填写是否配置完成"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="是否需要材料配置" prop="isNeedMaterial"
                :rules="[
                 ]">
              <el-input v-model="inputForm.isNeedMaterial" placeholder="请填写是否需要材料配置"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="工程类别" prop="kindId1"
                :rules="[
                 ]">
              <el-input v-model="inputForm.kindId1" placeholder="请填写工程类别"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="工程类型" prop="kindId2"
                :rules="[
                 ]">
              <el-input v-model="inputForm.kindId2" placeholder="请填写工程类型"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="项目名称" prop="name"
                :rules="[
                 ]">
              <el-input v-model="inputForm.name" placeholder="请填写项目名称"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="施工指示" prop="workPoint"
                :rules="[
                 ]">
              <el-input v-model="inputForm.workPoint" placeholder="请填写施工指示"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="常规标准" prop="workStandard"
                :rules="[
                 ]">
              <el-input v-model="inputForm.workStandard" placeholder="请填写常规标准"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="注意事项" prop="workNote"
                :rules="[
                 ]">
              <el-input v-model="inputForm.workNote" placeholder="请填写注意事项"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="施工单位" prop="workUnitId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.workUnitId" placeholder="请填写施工单位"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="单位信息id" prop="unitId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.unitId" placeholder="请填写单位信息id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="关联其他工程ID" prop="otherProjectId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.otherProjectId" placeholder="请填写关联其他工程ID"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="关联其他必选工程项目编号" prop="otherRequireProjectIds"
                :rules="[
                 ]">
              <el-input v-model="inputForm.otherRequireProjectIds" placeholder="请填写关联其他必选工程项目编号"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="图片" prop="picture"
                :rules="[
                 ]">
              <el-input v-model="inputForm.picture" placeholder="请填写图片"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="备注" prop="remarks"
                :rules="[
                 ]">
              <el-input v-model="inputForm.remarks" placeholder="请填写备注"     ></el-input>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecProjectService from '@/api/cecproject/cecProjectService'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          proCode: '',
          isFinish: '',
          isNeedMaterial: '',
          kindId1: '',
          kindId2: '',
          name: '',
          workPoint: '',
          workStandard: '',
          workNote: '',
          workUnitId: '',
          unitId: '',
          otherProjectId: '',
          otherRequireProjectIds: '',
          picture: '',
          remarks: ''
        }
      }
    },
    components: {
    },
    methods: {
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建项目表`
        } else if (method === 'edit') {
          this.title = '修改项目表'
        } else if (method === 'view') {
          this.title = '查看项目表'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecProjectService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecProjectService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>

  
